import { Component, OnInit } from '@angular/core';
import { AuthGuardService } from '../services/route-guard.service';
import { MemberRoleEnum } from 'src/enumerators';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.css'],
})
export class ServicesPageComponent implements OnInit {
  constructor(
    private _authGuard: AuthGuardService,
    private _authService: AuthService,
  ) { }

  ngOnInit(): void {
    this._authGuard.userSub.asObservable().subscribe(next => {
      if (!next) return
      this._authService.memberSub.asObservable().subscribe(nextMember => {
        if (!nextMember) return
        this._authGuard.checkForPermission([MemberRoleEnum.TeamLeader]);
      })
    })
  }


}
